<template>
	<v-card class="fill-height new-customer-form">
		<div class="quote-builder__card-inner inner-scroll">
			<v-card-text class="inner-scroll__scroller">
				<v-text-field
					v-model="form.name"
					outline
					label="Contact Name"
					:error="errors.has('name')"
					:error-count="errors.count('name')"
					:error-messages="errors.get('name')"
					@change="errors.clear('name')"
				></v-text-field>

				<v-text-field
					v-model="form.company"
					outline
					label="Company Name"
					:error="errors.has('company')"
					:error-count="errors.count('company')"
					:error-messages="errors.get('company')"
					@change="errors.clear('company')"
				></v-text-field>

				<v-text-field
					v-model="form.email"
					outline
					label="Contact Email Address"
					:error="errors.has('email')"
					:error-count="errors.count('email')"
					:error-messages="errors.get('email')"
					@change="errors.clear('email')"
				></v-text-field>

				<v-text-field
					v-model="form.phone"
					outline
					label="Contact Phone"
					mask="phone"
					:error="errors.has('phone')"
					:error-count="errors.count('phone')"
					:error-messages="errors.get('phone')"
					@change="errors.clear('phone')"
				></v-text-field>

				<v-text-field
					v-model="form.address"
					outline
					label="Street Address"
					:error="errors.has('address')"
					:error-count="errors.count('address')"
					:error-messages="errors.get('address')"
					@change="errors.clear('address')"
				></v-text-field>

				<v-text-field
					v-model="form.city"
					outline
					label="City"
					:error="errors.has('city')"
					:error-count="errors.count('city')"
					:error-messages="errors.get('city')"
					@change="errors.clear('city')"
				></v-text-field>

				<!-- <v-autocomplete
					v-model="form.state"
					label="State"
					:items="statesList()"
					item-text="name"
					item-value="abbreviation"
				></v-autocomplete>-->

				<v-autocomplete
					v-model="form.state"
					label="State"
					outline
					:items="states"
					:filter="filterStates"
					item-text="name"
					item-value="abbreviation"
					clearable
					browser-autocomplete="disabled"
					:error="errors.has('state')"
					:error-count="errors.count('state')"
					:error-messages="errors.get('state')"
				></v-autocomplete>

				<v-text-field
					v-model="form.zip"
					outline
					label="Zip Code"
					:error="errors.has('zip')"
					:error-count="errors.count('zip')"
					:error-messages="errors.get('zip')"
					@change="errors.clear('zip')"
				></v-text-field>
			</v-card-text>

			<v-card-actions class="pa-3">
				<v-btn outline @click="close">Cancel</v-btn>
				<v-spacer></v-spacer>
				<v-btn color="primary" @click="save">Save</v-btn>
			</v-card-actions>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Errors from "@root/helpers/Errors";

export default {
	data() {
		return {
			form: {
				name: "",
				company: "",
				address: "",
				address2: "",
				zip: "",
				city: "",
				state: "",
				email: "",
				phone: ""
			},
			errors: new Errors()
		};
	},

	computed: {
		...mapGetters(["dark", "statesList"]),

		states() {
			return this.statesList("US");
		}
	},

	methods: {
		save() {
			this.$emit("save", this.form);
		},

		close() {
			this.$emit("close");
		},

		resetForm() {
			_.forIn(this.form, (value, key) => {
				this.$set(this.form, key, "");
			});
		},

		populateForm(document) {
			_.forIn(this.form, (value, key) => {
				// console.log(document[`customer_${key}`]);
				this.$set(this.form, key, document[`customer_${key}`]);
			});
		},

		filterStates(item, queryText, itemText) {
			return (
				itemText
					.toLocaleLowerCase()
					.indexOf(queryText.toLocaleLowerCase()) > -1 ||
				item.abbreviation
					.toLocaleLowerCase()
					.indexOf(queryText.toLocaleLowerCase()) > -1
			);
		}
	}
};
</script>
